import { z } from 'zod';

export const SupplierRoleStatusSchema = z.enum(['ACTIVE', 'SUSPENDED', 'INACTIVE', 'BLOCKED']);
export type SupplierRoleStatus = z.infer<typeof SupplierRoleStatusSchema>;

export const SupplierPaymentTermsKindSchema = z.enum(['NET_DAYS', 'PREPAID', 'COD', 'ON_DELIVERY']);
export type SupplierPaymentTermsKind = z.infer<typeof SupplierPaymentTermsKindSchema>;

export const SupplierRoleResponseSchema = z.object({
  id: z.uuid(),
  partyId: z.uuid(),
  status: SupplierRoleStatusSchema,
  paymentTermsKind: SupplierPaymentTermsKindSchema,
  paymentDays: z.number().int().positive().nullable(),
  internalCode: z.string().nullable(),
  notes: z.string().nullable(),
  createdAt: z.iso.datetime(),
  updatedAt: z.iso.datetime(),
});

export type SupplierRoleResponse = z.infer<typeof SupplierRoleResponseSchema>;
